import React from 'react';
import {FormattedMessage} from 'react-intl';
import {TextStyle} from './DefaultText';
import {useFormatMsg} from 'utils/useFormatMsg';

/**
 * 기본 포맷된 메시지 컴포넌트의 Props 타입
 * @property {string} id - 메시지 ID
 * @property {string} [defaultMessage] - 기본 메시지
 * @property {any} [values] - 메시지 값
 * @property {React.CSSProperties} [style] - 스타일
 * @property {React.ElementType<any>} [tagName] - 태그 이름
 * @property {string} [tooltip] - 툴팁 텍스트
 */
type Props = {
  id: string;
  defaultMessage?: string;
  values?: any;
  style?: React.CSSProperties;
  tagName?: React.ElementType<any>;
  tooltip?: string;
};

/**
 * 기본 포맷된 메시지 컴포넌트
 * 국제화 메시지를 표시하는 컴포넌트입니다.
 * @param {Props} props - 포맷된 메시지 컴포넌트의 props
 * @returns {JSX.Element} 기본 포맷된 메시지 컴포넌트
 */
const DefaultFormattedMessage = ({
  id,
  defaultMessage,
  values,
  style,
  tagName,
  tooltip,
}: Props) => {
  const formatTooltip = (tooltip && useFormatMsg(tooltip)) || tooltip;
  return (
    <FormattedMessage
      tagName={tagName}
      id={id}
      defaultMessage={defaultMessage}
      values={values}>
      {formatTxt => (
        <TextStyle title={formatTooltip} as={tagName} style={style}>
          {formatTxt}
        </TextStyle>
      )}
    </FormattedMessage>
  );
};

export default DefaultFormattedMessage;
